import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, formValueSelector, Field } from 'redux-form';
import { Row, Col, Panel, Button } from 'react-bootstrap';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import Spinner from '../../Widgets/spinner';
import ContentWrapper from '../../Layout/ContentWrapper';
import { setDefaultOfForm } from '../../../actions/purchaseOrders_actions';
import { DatePicker } from '../../Common/datePicker';
import { fetchCityReport } from '../../../actions/arap_actions';

momentLocalizer(moment);

class CityReportSearchPanel extends Component {

  state = {
    maxDate: new Date(),
    fromDate: '1900-01-01',
    toDate: '3000-01-01',
  }

  componentWillMount() {
    this.props.setDefaultOfForm('fromDate', moment().subtract(7, 'days').toDate(), 'cityReportSearchPanelForm');
    this.props.setDefaultOfForm('toDate', moment().toDate(), 'cityReportSearchPanelForm');
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selectedCompany !== this.props.selectedCompany && this.props.selectedCompany) {
      this.fetchCityReport();
    }
    if (!nextProps.fromDate) {
      this.props.setDefaultOfForm('fromDate', moment().subtract(7, 'days').toDate(), 'cityReportSearchPanelForm');
    }
    if (!nextProps.toDate) {
      this.props.setDefaultOfForm('toDate', moment().toDate(), 'cityReportSearchPanelForm');
    }
    if (nextProps.fromDate && this.props.fromDate !== nextProps.fromDate) {
      // const { fromDate } = this.getFormattedDates();
      this.setState({ fromDate: nextProps.fromDate, toDate: nextProps.toDate }, this.fetchCityReport);
      this.props.handleFieldUpdate({ name: 'fromDate', value: nextProps.fromDate });
    }
    if (nextProps.toDate && this.props.toDate !== nextProps.toDate) {
      // const { toDate } = this.getFormattedDates();
      this.setState({ fromDate: nextProps.fromDate, toDate: nextProps.toDate }, this.fetchCityReport);
      this.props.handleFieldUpdate({ name: 'toDate', value: nextProps.toDate });
    }
  }

  getFormattedDates() {
    const defaultFrom = moment().subtract(7, 'days').format('YYYY-MM-DD');
    const defaultEnd = moment().format('YYYY-MM-DD');
    const fromDate = this.state.fromDate ? moment(this.state.fromDate).format('YYYY-MM-DD') : defaultFrom;
    const toDate = this.state.toDate ? moment(this.state.toDate).format('YYYY-MM-DD') : defaultEnd;
    return { fromDate, toDate };
  }

  // handleFormSubmit = (formProps) => {
  //   const { fromDate, toDate } = this.getFormatedDates(formProps);
  //   this.props.fetchCityReport({ fromDate, toDate });
  // }

  fetchCityReport() {
    const { fromDate, toDate } = this.state;
    this.props.fetchCityReport({ fromDate, toDate }, this.props.selectedCompany);
  }

  renderSpinner() {
    if (this.props.cityReportIsLoading && !this.props.cityReportError) {
      return (
        <div id="spinner">
          <Spinner />
        </div>
      );
    } // else if (this.props.cityReportError) {
    //   return (
    //     <ContentWrapper>
    //       <div className="alert alert-danger">
    //         <Translate value="something_unexpected_happened" />
    //       </div>
    //     </ContentWrapper>
    //   );
    // }
    return <div />;
  }

  render() {
    const { maxDate } = this.state;
    const {
      fromDate,
      toDate,
    } = this.props;
    return (
      <Panel>
        <Row>
          <Col xs={12}>
            {/* <form onSubmit={handleSubmit(this.handleFormSubmit)}> */}
            <Col xs={5}>
              <Col xs={1}>
                <label className="pull-right">
                  <Translate value="from" />
                </label>
              </Col>
              <Col xs={3}>
                <div className="control-date-picker">
                  <Field
                    name="fromDate"
                    component={DatePicker}
                    placeholder="From"
                    maxDate={toDate}
                  />
                </div>
              </Col>
                <Col xs={1}>
                <label className="pull-right">
                  <Translate value="to" />
                </label>
              </Col>
              <Col xs={3}>
                <div className="control-date-picker">
                  <Field
                    name="toDate"
                    component={DatePicker}
                    placeholder="To"
                    minDate={fromDate}
                    maxDate={maxDate}
                  />
                </div>
              </Col>
              {/* <Col xs={1}>
                 <Button
                  bsStyle="primary"
                  className="search-btn"
                  type="submit"
                  disabled={submitting}
                >
                  <em className="fa fa-search" />
                </Button>
              </Col> */}
            </Col>
            <Col xs={4}>
              {this.renderSpinner()}
            </Col>
            {/* </form> */}
          </Col>
        </Row>
      </Panel>
    );
  }
}

const CityReportSearchPanelForm = reduxForm({
  form: 'cityReportSearchPanelForm',
})(CityReportSearchPanel);

const selector = formValueSelector('cityReportSearchPanelForm');

function mapStateToProps(state) {
  const fromDate = selector(state, 'fromDate');
  const toDate = selector(state, 'toDate');
  return {
    fromDate,
    toDate,
    cityReportIsLoading: state.arap.cityReport.cityReportIsLoading,
    cityReportError: state.arap.cityReport.cityReportError,
    selectedCompany: state.header.selectedCompany
  };
}

export default connect(mapStateToProps, {
  fetchCityReport,
  setDefaultOfForm,
})(CityReportSearchPanelForm);



// WEBPACK FOOTER //
// ./master/jsx/components/AR/CityReport/cityReportSearchPanel.jsx